import type { NavigationGuardWithThis } from 'vue-router';
import type { PermissionsCodename } from 'src/api';
import { useUser } from 'stores/user/useUser';
import { deniedRedirect } from './deniedRedirect';

// Redirects to home when the user is missing any of the given permissions.
// Sibling of `requireCompanyPermission`; combine the two with vue-router's
// array form when a route needs both: `beforeEnter: [requireUserPermission(...), requireCompanyPermission(...)]`.
export const requireUserPermission = (
  ...permissions: PermissionsCodename[]
): NavigationGuardWithThis<undefined> => {
  return (to, from, next): void => {
    const userStore = useUser();
    if (
      !permissions.every((permission) =>
        userStore.handleUserHasPermission(permission)
      )
    ) {
      return next(deniedRedirect(to));
    }
    return next();
  };
};
